<div
    class="bazis-slider"
    swipe
    (swipeLeft)="slideEnd()"
    (swipeRight)="slideStart()"
>
    <div class="bazis-slider__wrapper">
        <div
            class="bazis-slider__content"
            #sliderContainer
            [style.transform]="'translateX(' + shift + 'px)'"
        >
            <ng-content></ng-content>
        </div>
    </div>

    @if (containerWidth < allSlidesWidth) {
        <div class="bazis-slider__controls">
            <bazis-button
                [fill]="typeButton()"
                color="action"
                [size]="sizeButton()"
                class="bazis-slider__prev"
                [disabled]="shift === 0"
                (click)="slideStart()"
            >
                <bazis-icon
                    slot="icon-only"
                    [icon]="iconPrev()"
                ></bazis-icon>
            </bazis-button>

            <bazis-button
                [fill]="typeButton()"
                color="action"
                [size]="sizeButton()"
                class="bazis-slider__next"
                [disabled]="isEndSlider"
                (click)="slideEnd()"
            >
                <bazis-icon
                    slot="icon-only"
                    [icon]="iconNext()"
                ></bazis-icon>
            </bazis-button>
        </div>
    }

    @if (list && hasIndicator()) {
        @let counter = swipesCounter.$ | async;
        @if (counter) {
            <div class="bazis-slider__indicator">
                @for (indicator of [].constructor(counter); let dot = $index; track $index) {
                    <div
                        class="bazis-slider__indicator__item"
                        [class.bazis-slider__indicator__item--active]="dot === currentSwipe"
                    >
                    </div>
                }
            </div>
        }
    }
</div>

@let techVar = list$ | async;
